import { render, staticRenderFns } from "./DocumentsGroupTableItem.vue?vue&type=template&id=09583fd8&scoped=true&"
import script from "./DocumentsGroupTableItem.vue?vue&type=script&lang=js&"
export * from "./DocumentsGroupTableItem.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsGroupTableItem.vue?vue&type=style&index=0&id=09583fd8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09583fd8",
  null
  
)

export default component.exports